<template>
  <div class="content">
    <div class="left">
      <img
        src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_624fce0d3b7c9/387471563.png"
        alt=""
      />
    </div>
    <div class="right">
      <div class="headline">- 作答区域 -</div>
      <div class="time">
        <span>剩余时间：</span>
        <span>{{ time }}</span>
      </div>
      <div class="title">
        把你的想法用语言、文字或者画图的方式，清晰准确的表达出来。
      </div>
      <div class="tip">
        <span>自动翻译：</span>
        <span class="success" v-if="successRecord">提交成功！</span>
      </div>
      <div class="record">
        <div>{{ record }}</div>
        <div class="collect" @click="startRecord">
          <img
            src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_624eaa56ce32f/594796574.png"
            alt=""
          />
          <span>点击录音</span>
        </div>
        <div class="submit" @click="submit">提交</div>
      </div>
      <div class="tip">
        <span>画板：</span>
        <span class="success" v-if="successDarwing">提交成功！</span>
      </div>
      <div class="darwing" ref="drawingPage">
        <canvas ref="drawing" :class="className"></canvas>
        <img
          src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_624fcdff8902b/288473915.png"
          alt=""
          class="pencil"
          @click="drawStart"
        />
        <img
          src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_624fcdfc03a2d/302629337.png"
          alt=""
          class="eraser"
          @click="eclear"
        />
        <div class="submit" @click="submitDarwing">提交</div>
      </div>
      <div class="next" @click="go">下一题</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      submitList: [],
      record: '',
      successRecord: false,
      successDarwing: false,
      time: '00:00',
      className: ''
    };
  },
  mounted() {
    // eslint-disable-next-line
    this.recognition = new webkitSpeechRecognition();
    this.recognition.continuous = true;
    this.recognition.interimResults = true;
    this.recognition.lang = 'cmn-Hans-CN'; // 普通话 (中国大陆)
    this.recognition.onresult = e => {
      // console.log(e.results.length, e.results[0].length, e);
      // console.log(e.results[0][0], e.results[0][0].transcript);
      this.record = '';
      for (const key in e.results) {
        if (Object.hasOwnProperty.call(e.results, key)) {
          const element = e.results[key];
          this.record += element[0].transcript;
        }
      }
    };
    this.recognition.onerror = function(event) {
      console.log(event);
    };
    // 计算倒计时
    let allTime = 10 * 60;
    setInterval(() => {
      if (allTime === 0) return;
      allTime--;
      this.time = Math.floor(allTime / 60) + ':' + (allTime % 60);
    }, 1000);
    // 画板初始化
    this.initCanvas();
  },
  methods: {
    initCanvas() {
      const dom = this.$refs.drawingPage;
      this.canvas = this.$refs.drawing;
      this.ctx = this.canvas.getContext('2d');
      const width = dom.getBoundingClientRect().width;
      const height = dom.getBoundingClientRect().height;
      this.canvas.width = width;
      this.canvas.height = height;
      // this.ctx.fillStyle = '#fff'
      this.ctx.fillStyle = 'transparent';
      // 绘制一个填充内容得矩形，从左上点（x,y)开始，其宽高分别由width和height确定，填充样式由当前得fillStyle决定
      this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
    },
    lister(canvas) {
      // 监听鼠标事件 用drawCircle()方法把记录的数据画出来
      // console.log(ctx.strokeStyle)
      let painting = false;
      let lastPoint = { x: 0, y: 0 };
      // console.log('0', document.body.ontouchstart)
      if (document.body.ontouchstart !== undefined) {
        canvas.ontouchstart = e => {
          // console.log('touch', e)
          // 返回一个
          painting = true;
          const x = e.touches[0].pageX - canvas.getBoundingClientRect().left;
          const y = e.touches[0].pageY - canvas.getBoundingClientRect().top;
          lastPoint = { x, y };
          this.ctx.save();
          this.drawCircle(canvas, x, y, 0);
        };
        canvas.ontouchmove = e => {
          // console.log('touchmove', e)
          if (painting) {
            const x = e.touches[0].pageX - canvas.getBoundingClientRect().left;
            const y = e.touches[0].pageY - canvas.getBoundingClientRect().top;
            const newPoint = { x, y };
            this.drawLine(
              canvas,
              lastPoint.x,
              lastPoint.y,
              newPoint.x,
              newPoint.y
            );
            lastPoint = newPoint;
          }
        };
        canvas.ontouchend = () => {
          painting = false;
          this.saveImage(canvas);
        };
      } else {
        canvas.onmousedown = e => {
          painting = true;
          const x = e.clientX - canvas.getBoundingClientRect().left;
          const y = e.clientY - canvas.getBoundingClientRect().top;
          lastPoint = { x, y };
          this.ctx.save();
          this.drawCircle(canvas, x, y, 0);
        };
        canvas.onmousemove = e => {
          // console.log(painting)
          if (painting) {
            const x = e.clientX - canvas.getBoundingClientRect().left;
            const y = e.clientY - canvas.getBoundingClientRect().top;
            const newPoint = { x, y };
            this.drawLine(
              canvas,
              lastPoint.x,
              lastPoint.y,
              newPoint.x,
              newPoint.y
            );
            lastPoint = newPoint;
          }
        };
        canvas.onmouseup = () => {
          painting = false;
          // this.saveImage(canvas);
        };
        canvas.mouseleave = () => (painting = false);
      }
    },
    drawCircle(canvas, x, y, radious) {
      this.ctx.save();
      this.ctx.beginPath();
      this.ctx.arc(x, y, radious, 0, Math.PI * 2);
      this.ctx.fill(); // 根据当前填充样式 填充当前或已存在得路径方法
      if (this.clear) {
        this.ctx.clip(); // 将当前创建路径设置为裁剪路径的方法
        this.ctx.clearRect(0, 0, canvas.width, canvas.height); // 通过把像素设置为透明以达到一个矩形区域的目的
        this.ctx.restore(); // 从栈中弹出储存图形状态并恢复属性、剪切路径和变换矩阵的值
      }
    },
    drawLine(canvas, m, n, x, y) {
      this.ctx.lineWidth = 2; // 设置线段的宽度
      this.ctx.strokeStyle = this.lColor;
      this.ctx.fillStyle = this.lColor;
      this.ctx.lineCap = 'round'; // 指定绘制每条线段末端的属性 butt 方 round 圆 square 末端以方形结束，但增加了一个宽度和线段想同，高度是线段厚度一半的矩形区域
      this.ctx.lineJoin = 'round'; // 连接两个长度不为0的部分 否则忽略
      if (this.clear) {
        this.ctx.lineWidth = 20;
        this.ctx.save();
        this.ctx.globalCompositeOperation = 'destination-out';
        this.ctx.moveTo(m, n);
        this.ctx.lineTo(x, y);
        this.ctx.stroke();
        this.ctx.closePath();
        this.ctx.clip();
        this.ctx.clearRect(0, 0, canvas.width, canvas.height);
        this.ctx.restore();
      } else {
        this.ctx.moveTo(m, n); // 将一个新的子路径的起始点移动到（x, y）坐标的方法
        this.ctx.lineTo(x, y); // 使用直线连接子路径的终点到x, y方法（并不会真正绘制）
        this.ctx.stroke(); // 使用非零环绕规则，根据当前画线样式，绘制当前或已存在的路径方法
        // console.log('*************')
        this.ctx.closePath(); // 将笔点返回到当前子路径起始点的方法 尝试从当前点到起始点绘制一条直线 若已封闭或只有一个点则不会做任何操作
      }
    },
    drawStart() {
      this.className = 'pre';
      this.clear = false;
      this.lister(this.canvas);
      // console.log('点击使用白板画笔功能')
    },
    eclear() {
      this.className = 'eclean';
      this.clear = true;
    },
    startRecord(e) {
      this.recognition.start();
      this.$message.info('开始录音');
      this.record = '';
    },
    submit() {
      this.successRecord = true;
      this.record = '';
      this.recognition.stop();
      this.$message.info('录音完毕');
      this.submitList.push({});
    },
    submitDarwing() {
      this.className = '';
      this.successDarwing = true;
    },
    go() {
      if (!this.successDarwing || !this.successRecord) {
        this.$message.info('请提交作答后再进行一下题');
      } else {
        this.$message.info('演示结束啦');
      }
    }
  }
};
</script>

<style lang="less" scoped>
.content {
  width: 100%;
  height: 100%;
  display: flex;
  .left {
    width: 45%;
    background-image: url(http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_624e9378b4f7a/606856192.png);
    background-size: 100% 100%;
    padding: 4% 2%;
    overflow-y: auto;
    img {
      width: 100%;
    }
  }
  .right {
    width: 55%;
    background-image: url(http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_624e98747c556/505248194.png);
    background-size: 100% 100%;
    padding: 0 28px;
    box-sizing: border-box;
    overflow-y: auto;
    padding-bottom: 100px;
    .headline {
      width: 100%;
      padding-top: 34px;
      text-align: center;
      font-size: 18px;
      font-weight: 500;
      color: #2144ff;
      line-height: 25px;
      margin-bottom: 44px;
    }
    .time {
      margin-top: 20px;
      span {
        font-size: 16px;
        font-weight: 600;
        color: #35383e;
        line-height: 22px;
      }
      span:nth-child(2) {
        color: #39ab91;
      }
    }
    .title {
      margin-top: 22px;
      font-size: 16px;
      font-weight: 500;
      color: #000000;
      line-height: 22px;
    }
    .desc {
      font-size: 16px;
      font-weight: 400;
      color: #383838;
      line-height: 26px;
      margin-top: 12px;
    }
    .tip {
      padding-top: 22px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      span {
        font-size: 16px;
        font-weight: 400;
        color: #666d73;
        line-height: 22px;
      }
      .success {
        color: #39ab8f;
      }
    }
    .record {
      width: 100%;
      height: 238px;
      background: #f8f8f8;
      border: 1px solid #efefef;
      padding: 24px;
      position: relative;
      margin-top: 12px;
      > div {
        font-size: 16px;
        font-weight: 400;
        color: #383838;
        line-height: 26px;
      }
      .collect {
        position: absolute;
        left: 24px;
        bottom: 24px;
        width: 127px;
        height: 33px;
        background: #4594fb;
        box-shadow: 0px 5px 6px -4px rgba(41, 54, 242, 0.31),
          inset 0px 3px 8px 0px rgba(255, 255, 255, 0.48);
        border-radius: 17px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        span {
          font-size: 12px;
          font-weight: 400;
          color: #ffffff;
          line-height: 17px;
        }
        > img {
          width: 24px;
          margin-right: 4px;
        }
      }
      .submit {
        cursor: pointer;
        position: absolute;
        right: 24px;
        bottom: 24px;
        width: 119px;
        height: 33px;
        background: #ffffff;
        box-shadow: 0px 0px 8px -4px rgba(0, 0, 0, 0.25);
        border-radius: 6px;
        border: 1px solid #d9dadc;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        font-weight: 400;
        color: #000000;
        line-height: 17px;
      }
    }
    .darwing {
      width: 100%;
      height: 638px;
      background: #ffffff;
      border: 2px solid #efefef;
      margin-top: 12px;
      position: relative;
      canvas {
        width: 100%;
        height: 100%;
      }
      .pencil,
      .eraser {
        width: 23px;
        position: absolute;
        left: 24px;
        bottom: 28px;
        cursor: pointer;
      }
      .eraser {
        left: 72px;
      }
      .submit {
        cursor: pointer;
        position: absolute;
        right: 24px;
        bottom: 24px;
        width: 119px;
        height: 33px;
        background: #ffffff;
        box-shadow: 0px 0px 8px -4px rgba(0, 0, 0, 0.25);
        border-radius: 6px;
        border: 1px solid #d9dadc;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        font-weight: 400;
        color: #000000;
        line-height: 17px;
      }
    }
    .next {
      width: 269px;
      height: 44px;
      background: #f8f9ff;
      border-radius: 6px;
      border: 1px solid #4594fb;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      font-weight: 400;
      color: #4594fb;
      line-height: 20px;
      margin: 0 auto;
      margin-top: 37px;
      cursor: pointer;
    }
  }
}
.pre {
  // position: relative;
  // z-index: 5;
  cursor: url("./image/icon_shubiao_qianbi.png") 10 26, default;
}
.eclean {
  // position: relative;
  // z-index: 5;
  cursor: url("./image/icon_shubiao_heibanca.png") 22 15, default;
}
</style>
